<template>
  <div class="hash-algorithm-update">
    <div class="row" style="margin: 15px;">
      <h2>Important Security Update at Bravenet</h2>
      <div class="column-wrapper">
        <div class="column">
          <p>Your security is important to us, and we are always improving at Bravenet. We have just implemented new, more robust, secure hashing algorithms.</p>
          <p class="accent">As part of this upgrade we need you to <strong>reset your password</strong>.<br>An email has been sent to <a class="email-sent underline">{{suspiciousEmail}}</a>.<br>Please follow the steps to update your credentials.</p>
          <p>Once you have reset your password, you may refresh this page and resume activity within your account.</p>
          <p>Thank you so much for your understanding and co-operation.<br>It is important that we always stay on top of security.<br>If your primary email address is hosted on Bravenet, you may gain access to it through <a class="underline" href="https://webmail.bravehost.com/">webmail</a>.<br>If you have any problems, please <a class="underline" href="https://www.bravenet.com/help/postquestion.php?action=securityupdate">contact support</a>.</p>
          <p>The Team at Bravenet</p>
        </div>
        <div class="column">
          <img src="//assets.bravenet.com/common/images/shieldlock_thumb.png">
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.modal-container {
  width: 90vw;
  max-width: 1170px;
}
.hash-algorithm-update {
  padding: 50px;
  line-height: 20px;
  h2 {
    font-size: 30px;
    margin-bottom: 10px;
  }

  p {
    margin: 20px 0;
    font-size: 14px;
  }
  .column-wrapper {
    white-space: nowrap;
  }

  .column {
    display: inline-block;
    width: 70%;
    white-space: normal;
  }

  .column:last-child {
    width: 30%;
    vertical-align: top;
    padding: 10px 60px;
  }

  .accent {
    background: #fcf8e3;
    padding: 20px;
    strong {
      font-weight: 500;
    }
  }
}


</style>
<script>
export default {
  props: ['suspiciousEmail']
}
</script>